import { render, staticRenderFns } from "./createClassroomIntelligentBody.vue?vue&type=template&id=e0282eba&scoped=true"
import script from "./createClassroomIntelligentBody.vue?vue&type=script&lang=js"
export * from "./createClassroomIntelligentBody.vue?vue&type=script&lang=js"
import style0 from "./createClassroomIntelligentBody.vue?vue&type=style&index=0&id=e0282eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0282eba",
  null
  
)

export default component.exports